import clsx from "clsx"
import React from "react"

import PageContainer from "./PageContainer"

export type NavbarProps = {
  className?: string
  slotEnd?: React.ReactNode
}

const Navbar = ({ className }: NavbarProps) => {
  return (
    <div className={clsx("sticky top-0 z-[calc(theme(zIndex.dialog)-1)]")}>
      <nav
        className={clsx(
          "relative h-[62px] border border-b-onSurface-200 bg-white",
          className,

          "flex items-center py-1"
        )}
      >
        <PageContainer className="w-full">
          <div
            className={clsx(
              "flex w-full flex-wrap items-center justify-between sm:flex-nowrap sm:justify-start"
            )}
          >
            <div className="flex grow items-center justify-center md:block md:grow-0">
              <span>
                <a href={import.meta.env.VITE_SURAASA_PLATFORM_URL}>
                  <img
                    alt="suraasa logo"
                    src="https://www.suraasa.com/assets/logos/suraasa-logo-new.svg"
                  />
                </a>
              </span>
            </div>
          </div>
        </PageContainer>
      </nav>
    </div>
  )
}

export default Navbar
